import * as yup from 'yup';

export const ERROR_MESSAGE = {
  MOVABLE_PROPERTY_VALID: 'Preenchimento obrigatório',
  TOTAL_INVESTED_QUALIFIED_VALID:
    'Como você se declarou como investidor qualificado, você deve ter 1 milhão ou mais em investimentos.',
  TOTAL_INVESTED_PROFESSIONAL_VALID:
    'Como você se declarou como investidor profissional, você deve ter 10 milhões ou mais em investimentos.'
};

export const schema = yup.object().shape({
  movableProperty: yup
    .number()
    .test(
      'movable-property-validation',
      ERROR_MESSAGE.MOVABLE_PROPERTY_VALID,
      function (value) {
        const monthlyIncome = this.parent.monthlyIncome;
        if (monthlyIncome === 0) {
          return value >= 100;
        }
        return true;
      }
    )
    .required(),
  totalInvested: yup
    .number()
    .test(
      'total-invested-validation',
      ERROR_MESSAGE.TOTAL_INVESTED_QUALIFIED_VALID,
      function (value) {
        const { isQualifiedInvestor } = this.parent;
        return !(isQualifiedInvestor && value < 1000000);
      }
    )
    .test(
      'total-invested-validation',
      ERROR_MESSAGE.TOTAL_INVESTED_PROFESSIONAL_VALID,
      function (value) {
        const { isProfessionalInvestor } = this.parent;
        return !(isProfessionalInvestor && value < 10000000);
      }
    )
    .required()
});
